import React from 'react';
import './index.scss';
import { HEADER_TEXT, formatPct } from './constants';
import AsyncSection from '../../../../../../../../Components/AsyncSection';
import SectionHeader from '../../../SectionHeader';

const LimitedVisibility = (props) => {
    let groupColumns = props.fetchCantAnswerResponseApi.data && props.fetchCantAnswerResponseApi.data.groupColumns ? props.fetchCantAnswerResponseApi.data.groupColumns : []
    let limitedVisibilityBehaviour = props.fetchCantAnswerResponseApi.data && props.fetchCantAnswerResponseApi.data.behaviors ? props.fetchCantAnswerResponseApi.data.behaviors : []
    return (
        <AsyncSection api={props.fetchCantAnswerResponseApi}>
            <SectionHeader
                title={HEADER_TEXT.title}
                description={HEADER_TEXT.description}
            />
        <div className='cardwrapper'>
            <div className='limvis'>
                <div className='limvis__title'>Top 3 Behaviors with "Can't Answer" Responses</div>
                <div className='limvis__subtitle'>
                    Behaviors where stakeholders most often selected 'Can't Answer', suggesting
                    limited visibility. Review whether the right raters are being asked about these
                    behaviors.
                </div>

                <div className='limvis__table-wrap'>
                    <table className='limvis__table'>
                        <thead>
                            <tr>
                                <th className='limvis__th limvis__th--category'>Category</th>
                                <th className='limvis__th limvis__th--behavior'>Behavior</th>
                                <th className='limvis__th limvis__th--count'>Count</th>
                                    {groupColumns.map((col) => (
                                    <th key={col.key} className='limvis__th limvis__th--num'>
                                        <span className='limvis__th-stack'>
                                            <span className='limvis__th-pct'>%</span>
                                            <span>{col.label}</span>
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                                {limitedVisibilityBehaviour.map((row) => (
                                <tr key={row.category}>
                                    <td className='limvis__td limvis__td--category'>{row.category}</td>
                                    <td className='limvis__td limvis__td--behavior'>{row.behavior}</td>
                                    <td className='limvis__td limvis__td--count'>{row.count.toLocaleString()}</td>
                                        {groupColumns.map((col) => (
                                        <td
                                            key={col.key}
                                            className={`limvis__td limvis__td--num${col.strong ? ' limvis__td--strong' : ''}`}
                                        >
                                            {formatPct(row[col.key])}
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className='limvis__note'>
                    % Overall = share of all responses to that behavior marked "Can't Answer". Group
                    columns = share within each stakeholder group.
                </div>
            </div>
        </div>
        </AsyncSection>
    );
};

export default LimitedVisibility;
